export default {
  "b2b.fixniPozadavkyBox.textErrorSmlouvaFixni":
    "The contract for the selected project does not contain any fixed claims",
  "b2b.fixniPozadavkyBox.textFixni": "Fixed",
  "b2b.fixniPozadavkyBox.textObdobi": "Period of requirements",
  "b2b.fixniPozadavkyBox.textVsechny": "Others",
  "b2b.fixniPozadavkyBox.title": "Phase of requirements",
  "b2b.fixniPozadavkyBox.titleClose":
    "Now it is not possible to enter requests",
  "b2b.fixniPozadavkyBox.titleErrorClosed":
    "Now it is not possible to enter requests",
  "b2b.fixniPozadavkyBox.titleErrorSmlouvaFixni":
    "Now it is possible to submit requests only for FIXED claims",
  "b2b.fixniPozadavkyBox.titleOpenFixni":
    "Now it is possible to enter requests for FIXED claims",
  "b2b.fixniPozadavkyBox.titleOpenVsechny":
    "Now it is possible to enter requests"
};
